import {MacRentals} from '@/components/MacRentals';
import {MacCatalog} from '@/components/MacCatalog';
/** Customer selection comes exclusively from the authenticated connector catalog. */
export function MachinesPage(){return <><MacRentals /><MacCatalog /></>;}
